export default "__VITE_ASSET__OhQBbV6D__"